import typeof { DEFAULT_VOLUME_RATIOS as Volumes } from '@mission.io/mission-toolkit/constants'
// TODO: Remove when using shared simulation types
export const VOCAL_TRACK_DISPLAY_IDS = {
	ICON_ONLY: 'ICON_ONLY',
	SHOW_CHARACTER: 'SHOW_CHARACTER',
}

export const ONE_SECOND = 1000
export const ONE_MINUTE = 60 * ONE_SECOND
export const ONE_HOUR = 60 * ONE_MINUTE

type VolumeType = $Keys<Volumes>
export const VOLUMES: { [VolumeType]: VolumeType } = {
	EFFECTS: 'EFFECTS',
	VIDEO: 'VIDEO',
	VOCAL_TRACK: 'VOCAL_TRACK',
	AMBIANCE: 'AMBIANCE',
	MUSIC: 'MUSIC',
}

export const AUDIO_DUCK_SOURCES = {
	// During vocal tracks, all volumes (except vocal tracks) will be reduced by this percentage
	VOCAL_TRACK: {
		PERCENTAGE: 0.5,
	},
	// During CCM reviews, all volumes (except vocal tracks) will be reduced by this percentage
	CCM_REVIEW: {
		PERCENTAGE: 0.9,
	},
}
export type AudioDuckSource = $Keys<typeof AUDIO_DUCK_SOURCES>
// How long it takes for the ducking value to go from 0 -> AUDIO_DUCKING_PERCENTAGE
export const AUDIO_DUCKING_DELAY = 1000

/**
 The Main Screen is only 87% of the total height of the Player screen.
 So when we shrink the Main Screen to fit for ASL videos, 
 we need to take this into account.
 */
export const VIDEO_HEIGHT_OF_TOTAL_SCREEN_HEIGHT_PERCENTAGE = 1

/**
 * Calculated to see how best to fit a 16:9 div atop a 13% height footer.
 * The logic was if we have a 1920x1080 screen, and we want a footer to go underneath the
 * image that is 13% of the total height.
 */
export const CONTAINER_ASPECT_RATIO =
	(1920 * VIDEO_HEIGHT_OF_TOTAL_SCREEN_HEIGHT_PERCENTAGE) / 1080

/**
 * Used to determine the minimum dimensions of the div being drawn to before scaling to the correct dimensions
 */
const MIN_DIMENSION_SCALE = 1500 // chosen arbitrarily
export const MIN_PRE_SCALE_DIMENSIONS = {
	height: MIN_DIMENSION_SCALE * CONTAINER_ASPECT_RATIO,
	width: MIN_DIMENSION_SCALE / CONTAINER_ASPECT_RATIO,
}

export const CSS_PLAYER_HEIGHT_UNIT = '--ph' // a css "unit" variable representing 1 / 100th of the player height
export const CSS_PLAYER_WIDTH_UNIT = '--pw' // a css "unit" variable representing 1 / 100th of the player width

/**
 * cssPlayerHeightUnit - a helper function to using the player height unit (ph)css variable
 *
 * @param  {number} amount - the amount of ph units to use
 *
 * @returns string - css string representing ${amount}ph
 */
export function cssPlayerHeightUnit(amount: number): string {
	return `calc(var(${CSS_PLAYER_HEIGHT_UNIT}) * ${amount})`
}
